<template>
  <div :class="$style.search">
    <div :class="$style.searchInputContainer">
      <ion-icon
        name="md-search"
        :class="$style.searchIcon"
        size="medium"
      />
      <input
        type="text"
        :class="$style.searchInput"
        placeholder="Search for a country"
        @input="searchQueryHandler"
      >
    </div>
    <!--
      Country Suggestion Here
     -->
    <ul
      v-if="suggestions"
      :class="$style.suggestions"
    >
      <li
        v-for="country in suggestions"
        :key="country.callingCodes"
        :class="$style.suggestionItem"
      >
        <router-link
          :to="{name: 'Country Details', params: {countryName: country.name}}"
          :class="$style.suggestionLink"
        >
          <img
            :src="country.flag"
            :alt="`${country.name}'s National Flag`"
            :class="$style.suggestionFlag"
          >
          <span>{{ country.name }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    searchQuery: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line
    suggestions: [Array, null],
  },
  emits: ['update:searchQuery'],
  setup(_, { emit }) {
    const searchQueryHandler = (e) => {
      emit('update:searchQuery', e.target.value);
    };
    return {
      searchQueryHandler,
    };
  },
};
</script>

<style lang="scss" module>
@import '@/assets/scss/_shared.scss';

.search {
  width: 100%;
  position: relative;

  @include screenMedium {
    width: 30rem;
  }
}

.searchInputContainer {
  position: relative;

  .searchIcon {
    font-size: 1.3rem;
    color: $clr-input-text;
    color: var(--clr-input-text);
    position: absolute;
    top: 50%;
    left: 1.3rem;
    transform: translateY(-50%);
  }

  .searchInput {
    font-size: .875rem;
    font-size: clamp(.75rem, 3vw, .875rem);
    font-family: inherit;
    font-weight: 600;
    width: 100%;
    color: $clr-text;
    color: var(--clr-text);
    background-color: $clr-elements;
    background-color: var(--clr-elements);
    padding: 1em 1.5em 1em 3.75rem;

    border: none;
    border-radius: $border-radius-sm;
    box-shadow: $box-shadow-sm;

    &::placeholder {
      color: $clr-input-text;
      color: var(--clr-input-text);
    }
  }
}

.suggestions{
  background-color: $clr-elements;
  background-color: var(--clr-elements);
  position: absolute;
  z-index: 10;
  width: 100%;
  margin-top: 1rem;
  padding: .75em 1.5em;
  border-radius: $border-radius-sm;
  box-shadow: $box-shadow-sm;
}

.suggestion{

  &Item {
    list-style: none;
  }

  &Link {
    height: 2.5rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: $clr-text;
    color: var(--clr-text);
  }

  &Flag {
    width: 1.5rem;
    margin-right: .5em;
  }
}
</style>
